import React from "react";

import { setFilter } from "QuotePage/Actions";
import { useDispatch } from "react-redux";

import { Body2 } from "Cobalt/BodyText";
import { Title } from "Cobalt/Header";
import { Modal, ModalBody, ModalHeader, ModalFooter, type ModalHook } from "Cobalt/Modal";
import Button from "Common/Button";

export interface InStateParticipationModalProps extends ModalHook {
  state: string;
  onConfirm: () => void;
  onFilter: () => void;
}

export const InStateParticipationModal = ({ isShowing, hide, onFilter, state, onConfirm }: InStateParticipationModalProps) => {
  return (
    <Modal show={isShowing} onHide={hide}>
      <ModalHeader closeButton>
        <Title>Continue With In-State Only Plan?</Title>
      </ModalHeader>
      <ModalBody>
        <Body2>You have a selected an in-state only plan. Only employees who live in {state} will be eligible for this plan.</Body2>
      </ModalBody>
      <ModalFooter>
        <Button color="gray" key="close" onClick={onConfirm}>
          Continue
        </Button>
        <Button onClick={onFilter}>Filter In-State Plans</Button>
      </ModalFooter>
    </Modal>
  );
};
